export default __webpack_public_path__ + "static/29485-e4db67534f86c13eb5edf65d1b7be00f.jpg";